import { useEffect, useRef } from 'react'
import { fetchRigFloorReprocessingStatus } from '../services/api'
import { ContextStateType } from '../types/kpis-drilling/kpis-drilling-registry-type'

export const useRigFloorReprocessingPolling = ({
    setContextState,
    rigId,
    isRigFloorReprocessing,
    setIsRigFloorReprocessing,
    setIsSomeReprocessActivated
}: {
    setContextState: React.Dispatch<React.SetStateAction<ContextStateType>>
    rigId: string | null
    isRigFloorReprocessing: boolean
    setIsRigFloorReprocessing: React.Dispatch<React.SetStateAction<boolean>>
    setIsSomeReprocessActivated: React.Dispatch<React.SetStateAction<boolean>>
}): void => {
    const isRunningRef = useRef(isRigFloorReprocessing)
    const prevStatusRef = useRef<boolean | null>(null)

    useEffect(() => {
        isRunningRef.current = isRigFloorReprocessing
    }, [isRigFloorReprocessing])

    useEffect(() => {
        let isCancelled = false

        const poll = async (): Promise<void> => {
            if (!rigId || isCancelled) return

            try {
                if (isRunningRef.current) {
                    const res = await fetchRigFloorReprocessingStatus(rigId)
                    if (isCancelled) return

                    if (res.ok) {
                        const data = await res.json()
                        const isRunning = data?.status === 'running'

                        prevStatusRef.current = isRunning
                        setIsRigFloorReprocessing(isRunning)
                        if (typeof setContextState === 'function') {
                            setIsSomeReprocessActivated(true)
                            setContextState(prevState => ({
                                ...prevState,
                                reprocess: {
                                    ...prevState?.reprocess,
                                    rigfloor: {
                                        ...prevState?.reprocess?.rigfloor,
                                        isRigFloorReprocessing: isRunning
                                    }
                                }
                            }))
                        }
                    }
                }
            } catch (err) {
                console.error('Reprocessing polling error:', err)
            }

            if (!isCancelled) {
                setTimeout(poll, 1000)
            }
        }

        poll()

        return () => {
            isCancelled = true
            if (typeof setIsSomeReprocessActivated === 'function') {
                setIsSomeReprocessActivated(false)
            }
        }
    }, [rigId, setContextState, setIsRigFloorReprocessing, setIsSomeReprocessActivated])
}
